import {NullableKeys} from '@fl/cmsch-fe-library';

import {CreateOrUpdateRole} from 'api/gen/CreateOrUpdateRole';

/** Form name used by the role modal. */
export const roleFormName = 'role';

/** Initial values for the role form. */
export const roleInitialValues: NullableKeys<CreateOrUpdateRole> = {
    code: '',
    discriminatorId: null,
    name: '',
    userEnable: false,
};
